// extracted by mini-css-extract-plugin
module.exports = {"header":"RestaurantsListedByFiltered_header__2NWEV","component":"RestaurantsListedByFiltered_component__TAeHY","restaurant":"RestaurantsListedByFiltered_restaurant__2ww4w"};